module.exports = __webpack_public_path__ + "81be6a0fe0861bf47ba51fdb6c09a1b4.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/assets/beige/lbrcor.png
// module id = 2397
// module chunks = 0